import { shallowEqual, useSelector } from 'react-redux';
import { useMemo } from 'react';
import PropTypes from 'prop-types';
import ChannelEpisodes from '../../common/components/ChannelEpisodes';
import useSharedShowPageContext from '../../common/hooks/useSharedShowPageContext';
import useEpisodes from '../../common/hooks/useEpisodes';
import useShowUrlParams from '../../../../../hooks/shows/useShowUrlParams';
import ErrorWidget from '@/components/app/Error/ErrorWidget';
import { selectAudioPaused } from '@/state/selectors/audio';


const selector = (state) => ({ isPaused: selectAudioPaused(state) });

const EpisodesSection = ({ maxEpisodes }) => {
  const {
    episodeNumber: scrollToEpisodeNumber,
    seasonNumber: scrollToSeasonNumber
  } = useShowUrlParams();
  const {
    shouldScrollToEpisode,
    onScrolledToEpisode,
    haveSetSeasonFromUrl,
    onClickPlayEpisode,
    episodeScrollContainerRef,
    currentSeasonNumber
  } = useSharedShowPageContext();
  const {
    episodes: episodePreviews,
    isError,
    isLoading,
    isFetching,
    refetch
  } = useEpisodes();

  const { isPaused } = useSelector(selector, shallowEqual);

  const episodePreviewsTrimmed = useMemo(() => (maxEpisodes ? episodePreviews.slice(0, maxEpisodes) : episodePreviews), [maxEpisodes, episodePreviews]);

  return !isError ? (
    <ChannelEpisodes
      episodePreviews={episodePreviewsTrimmed}
      extraPadding
      haveSetSeasonFromUrl={haveSetSeasonFromUrl}
      isPaused={isPaused}
      loading={isLoading || !haveSetSeasonFromUrl}
      onClickPlayFromChannel={onClickPlayEpisode}
      onScrolledToEpisode={onScrolledToEpisode}
      scrollingRef={episodeScrollContainerRef}
      scrollToEpisodeNumber={scrollToEpisodeNumber}
      scrollToSeasonNumber={scrollToSeasonNumber}
      seasonId={currentSeasonNumber}
      shouldScrollToEpisode={shouldScrollToEpisode}
    />
  ) : (
    <ErrorWidget
      errorMessage="Failed to fetch episodes."
      onRetry={refetch}
      shouldDisplay={isError && !isFetching}
    />
  );
};

EpisodesSection.propTypes = { maxEpisodes: PropTypes.number };

EpisodesSection.defaultProps = { maxEpisodes: undefined };

export default EpisodesSection;
